// @import dependencies
import { store } from 'app_storage/redux-storage'
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {StudentdashboardModuleLayout} from 'app_components/modules/homeScreens/studentdashboard'
// @end

// @import events
import { sidebarComponentSelected } from 'app_events/app/actions'
import { IMyCourse } from 'app_types/campus/academic/myCoursesTypes'
// @end

// @import utils
// @end

// @import services
import storeService from 'app_services/storeService'
import InteractionService from 'app_services/interaction/interactionService'
import SchedulingService from 'app_services/campus/academic/schedulingService'
// @end

// @import types
import {IFetchScheduling} from 'app_types/campus/academic/schedulingTypes'
// @end

// @ADD Component types
interface IStudentdashboardModuleProps {}
interface IStudentdashboardModuleState {
  learningWay: IFetchScheduling | null | 'loading'
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class StudentdashboardModule extends Component<IStudentdashboardModuleProps, IStudentdashboardModuleState> {

  private schedulingService: SchedulingService
  storeObject = store
  private interactionService = new InteractionService()

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IStudentdashboardModuleProps) {
    super(props)
    this.state = {
      learningWay: null
    }
    this.schedulingService = new SchedulingService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    storeService?.subscribe('courses.courseSelected',this.handleChangeCourseSelected)
    this.storeObject.dispatch(sidebarComponentSelected({
      component: 'student_dashboard_sidebar'
    }))
    // @INFO Verificar si debe aparecer el modal informativo para el usuario
    this.interactionService.checkProfileInformation();
    // @INFO Consultar por una encuesta
    this.interactionService.checkSurveyAvailable();
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {
    storeService?.unsubscribe('courses.courseSelected',this.handleChangeCourseSelected)
    this.storeObject.dispatch(sidebarComponentSelected({
      component: null
    }))
  }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  /**
   * @INFO Cambia el curso seleccionado
   */
  private handleChangeCourseSelected = (_course?: IMyCourse) => {
    if(!_course) return
    this.fetchSchedulingData(_course)
  }

  fetchSchedulingData = async (data: IMyCourse | null) => {
    if (data) {
      this.setState({learningWay: 'loading'})
      if (data?._id) {
        const dataResponse = await this.schedulingService.fetchSchedulingData({
          moodle_id: data?._id,
          courseSchedulingId: data?.courseScheduling,
        }, {showError: false})
        if (dataResponse && dataResponse.program && dataResponse.courses ) {
          if (dataResponse.program && dataResponse.courses) {
            this.setState({learningWay: dataResponse})
          }
        } else {
          this.setState(({learningWay: null}))
        }
      } else {
        this.setState(({learningWay: null}))
      }
    } else {
      this.setState(({learningWay: null}))
    }
  }

  render() {
    return(
      <StudentdashboardModuleLayout
        learningWay={this.state.learningWay}
      />
    )
  }
}

export default connect(mapStatesToProps)(StudentdashboardModule)
